module.exports = __webpack_public_path__ + "img/infoBuy.dc294392.svg";